import React from 'react';
import { BaseTreeItem } from '@kastjs/runtime-core';
import LCDP from './components/lcdp-render-component';
import { Env } from './enum';

import type { PluginFunction } from '@kastjs/runtime-core';
import type { LcdpExtension } from './types';

export const loadScriptPromise = (src: string, loadFlag: string) => {
  if ((window as any)[loadFlag]) {
    return;
  }
  return new Promise((reslove, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.id = src;
    script.type = 'text/javascript';
    // 添加跨域属性
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);

    script.onload = () => {
      script.onload = script.onerror = null;
      (window as any)[loadFlag] = true;
      reslove(true);
    };

    script.onerror = function () {
      script.onerror = script.onload = null;
      reject(new Error('Failed to load ' + src));
    };
  });
};

export type KContext = Parameters<PluginFunction<any>>[0];

export const modifyMenuData = async (context: KContext, env: Env) => {
  const menuData = context.appSettings.routes;
  const selfModule = context.app?.['__selfModule__'] || { React };

  const helper = (list: BaseTreeItem<LcdpExtension & { lcdpAppId?: number }>[]) => {
    for (let item of list) {
      // 兼容之前的逻辑
      const appId = item.lcdp?.appId || item.lcdpAppId;
      const parserType = item.rpcExtend?.lcdp?.type === '灵构' ? 'lingo' : 'tangram';
      if (appId) {
        item.component = () =>
          selfModule.React.createElement(LCDP, {
            ...selfModule,
            id: appId as string,
            env,
            parserType,
          });
      }
      if (item.children && item.children.length > 0) {
        item.children = helper(item.children);
      }
    }
    return list;
  };
  helper(menuData);
  return menuData;
};

// 按照低码编译原理实现
export function addShare(valueMap: Record<string, any>): void {
  for (const key in valueMap) {
    if (valueMap.hasOwnProperty(key)) {
      window[key] = valueMap[key];
    }
  }
}

export function globalShareModules(shareModules: { [prop: string]: any }) {
  if (shareModules) {
    for (let key in shareModules) {
      // 没有才挂载
      if (!window[key]) {
        Object.defineProperty(window, key, {
          get() {
            return shareModules[key];
          },
          set() {
            console.warn(`window 上已有【${key}】实例，请不要重复挂载`);
          },
        });
      }
    }
  }
}
